import React from 'react';
import { Box, Typography } from '@mui/material';
import RomaneioVisualizar from '../components/romaneio/RomaneioVisualizar';

const RomaneioVisualizarPage: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <RomaneioVisualizar />
    </Box>
  );
};

export default RomaneioVisualizarPage;
